import { TranslationService } from '@lib/i18n/data-access';
import { ErrorMessages } from '@platform-workspace/design-system';
import { MinMaxLengthValidatorCallbackParams, VALIDATION_MESSAGES, ValidatorsKeys } from '@shared/utils/validators';

export const getDefaultChannelNameModalErrorMessages = (translationService: TranslationService): ErrorMessages => {
  return {
    [ValidatorsKeys.Required]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.Required]),
    [ValidatorsKeys.NonDefaultName]: translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.NonDefaultName]),
    [ValidatorsKeys.MaxLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MaxLength], { value: requiredLength });
    },
    [ValidatorsKeys.MinLength]: ({ requiredLength }: MinMaxLengthValidatorCallbackParams): string => {
      return translationService.translate(VALIDATION_MESSAGES[ValidatorsKeys.MinLength], { value: requiredLength });
    },
  };
};
